export const cilBritishPound = ["24 24","<path d='M17.622 7.5c-0.078-2.218-1.895-3.985-4.125-3.985-2.279 0-4.127 1.848-4.127 4.127 0 0 0 0 0 0v0 3.59h-2.996v1.5h2.996v5.639h-2.996v1.5h11.25v-1.5h-6.754v-5.639h5.254v-1.5h-5.254v-3.59c0-1.451 1.176-2.627 2.627-2.627s2.627 1.176 2.627 2.627v0 0.233h1.5v-0.375z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-british-pound.js
// module id = null
// module chunks = 